import { createChartOfAccount, getDropDownChartOfAccount } from '_services/accountingServices/accountingServices'
import { CommonCheckbox, CommonInput, CommonModal, CustomSelect } from 'components'
import CustomSelectAccount from 'components/CustomSelect/CustomSelectAccount'
import { UserContext } from 'context'
import { errorSchema, utils } from 'helper'
import React, { useContext, useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import StorageService from "utils/StorageServices/StorageServices";

const formObj = {
    company_id: StorageService.getCompanyId(),
    type: 1, // parent type like assets type 1
    account_type_id: {},
    name: '',
    parant_account_value: 0,
    parent_account_id: {},
    credit_or_debit: 0,
    opening_balance: 0,
    prefix: '',
}

const AddChartAccountModal = (props) => {

    let { isOpen, chartOfAccountList, isApiCall } = props;
    const [formValue, setFormValue] = useState(formObj);
    const [newData , setNewData] = useState({})
    const [formError, setFormError] = useState({});

    const [loading, setLoading] = useState(false);
    const [dropDownAccountType, setDropDownAccountType] = useState([])

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addEditChartOfAccountSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async () => {
        try {
            let object = {
                ...formValue,
                company_id: StorageService.getCompanyId(),
                type: newData?.option?.value ? newData?.option?.value : null, // parent type like assets type 1
                account_type_id: formValue?.account_type_id?.value ? formValue?.account_type_id?.value : null,
                parent_account_id: formValue?.parent_account_id?.value ? formValue?.parent_account_id?.value : null,
                credit_or_debit: 0,
                opening_balance: 0,
                prefix: '',
            }
            delete object.parant_account_value;
            const res = await createChartOfAccount(object);
            if (res?.responseCode === 200) {
                isApiCall();
                setFormValue({});
                setLoading(false);
                toast.success('Account Created Successfully');
                props.closeModal(); // Close the modal here
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const handleClick = async (e) => {
        e.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, errorSchema.addEditChartOfAccountSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            apiCallingFunction()
            setFormError("");
        } else {
            setFormError(validationResult);
            setLoading(false);
        }
    };

    // Pass closeModal as a prop to CommonModal
    const propsChartOfAccount = {
        ...props,
        onSubmit: handleClick,
        isLoadding: loading,
        disabled: loading,
        closeModal: props.closeModal
    }

    const callDropdownChartOfAccount = async (data) => {
        try {
            let payload = {
                company_id: StorageService.getCompanyId(),
                type: data?.option?.value,
                account_type_id: data?.sub?.subValue || null,
            }
            const res = await getDropDownChartOfAccount(payload);
            if (res?.responseCode === 200) {
                if (res?.data?.ChartOfAccount[0]?.data?.length > 0) {
                    setDropDownAccountType(commonFunction(res?.data?.ChartOfAccount[0]?.data));
                }
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onhandleSelect = async (item, name) => {
        if (name === 'account_type_id') {
            setNewData(item)
            await callDropdownChartOfAccount(item)
        }
        const stateObj = { ...formValue, [name]: (name === 'account_type_id') ? { label: item?.sub?.subLabel, value: item?.sub?.subValue } : item };
        setFormValue(stateObj);
        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addEditChartOfAccountSchema);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const checkboxHandler = (event, name) => {
        let value = event.target.checked ? 1 : 0;
        setFormValue((s) => ({ ...s, [name]: value }))
    }

    const commonFunction = (array) => {
        let newArray = []
        for (let i = 0; i < array.length; i++) {
            if (array[i]?.children?.length > 0 && typeof array[i]?.children === 'object') {
                newArray.push(array[i])
                newArray = newArray.concat(commonFunction(array[i]?.children));
            } else {
                newArray.push(array[i])
            }
        }
        return newArray;
    }

    return (
        <>
            <CommonModal {...propsChartOfAccount}>
                <div className="addLr_body">
                    <div className='_allDflx'>
                        <div>
                            <CustomSelectAccount
                                options={chartOfAccountList?.length > 0 ? chartOfAccountList?.map((el) => {
                                    return {
                                        label: el?.name,
                                        value: el?.type,
                                        sub_categories: el?.data?.map(subCat => ({
                                            subLabel: subCat?.name,
                                            subValue: subCat?.id,
                                            subType: subCat?.type,
                                        }))
                                    };
                                }) : []}
                                name="account_type_id"
                                flotingLabel="Account Type"
                                placeholder="Select Account Type"
                                value={formValue?.account_type_id}
                                error={formError["account_type_id.label"]}
                                onSelect={(data) => onhandleSelect(data, 'account_type_id')}
                            />
                        </div>

                        <div>
                            <CommonInput
                                type="text"
                                placeholder="Account Name"
                                label="Account Name *"
                                name='name'
                                value={formValue.name}
                                focus={!!(typeof formError === "object" && formError?.name)}
                                error={!!(typeof formError === "object") ? formError?.name : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                        </div>

                        <div>
                            <CommonCheckbox
                                className="_smallLab"
                                name="Make this a sub-account"
                                id="parant_account_value"
                                isChecked={formValue?.parant_account_value === 1}
                                handleClick={(e) => checkboxHandler(e, 'parant_account_value')}
                            />
                            {
                                formValue?.parant_account_value === 1 && (
                                    <div className='mt-2'>
                                        <CustomSelect
                                            options={dropDownAccountType?.map((el) => {
                                                return {
                                                    label: el?.name,
                                                    value: el?.id,
                                                    parent_account_id: el?.parent_account_id,
                                                    type: el?.type
                                                }
                                            })}
                                            name="parent_account_id"
                                            flotingLabel="Parent Account"
                                            value={formValue?.parent_account_id}
                                            // focus={formError["parent_account_id.label"]}
                                            error={formError["parent_account_id.label"]}
                                            onSelect={(data) => onhandleSelect(data, 'parent_account_id')}
                                            placeholder="Parent Account"
                                        />
                                    </div>
                                )
                            }
                        </div>

                        <div>
                            <CommonInput
                                type="text"
                                placeholder="Account Code"
                                label="Account Code * "
                                name='code'
                                value={formValue.code}
                                focus={!!(typeof formError === "object" && formError?.code)}
                                error={!!(typeof formError === "object") ? formError?.code : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                        </div>

                        <div>
                            <CommonInput
                                type="text"
                                placeholder="Description"
                                label="Description *"
                                name='desc'
                                value={formValue.desc}
                                focus={!!(typeof formError === "object" && formError?.desc)}
                                error={!!(typeof formError === "object") ? formError?.desc : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                        </div>
                    </div>
                </div>
            </CommonModal>
        </>
    )
}

export default AddChartAccountModal